/* eslint-disable no-shadow */
import React, { useState } from 'react';
import moment from 'moment';
import { useMount, useUpdateEffect } from 'react-use';
import { Divider, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  CAL_REGISTER_FIELD_CMD,
  CAL_REGISTER_FIELD_CMD_TOGGLE,
  CAL_REGISTER_FIELD_DATE,
  CAL_REGISTER_FIELD_GROUP_TOGGLE,
  CAL_REGISTER_FIELD_MONTHLY_DATEPICKER,
  CAL_REGISTER_FIELD_REPEAT,
  CAL_REGISTER_FIELD_TIME,
  CAL_REGISTER_FIELD_TIMES,
  CAL_REGISTER_FIELD_TITLE,
  CAL_REGISTER_FIELD_WEEK,
  CAL_REGISTER_FIELD_YEARLY_DATEPICKER,
  REGISTER_TOGGLE_GROUP_SELECT,
  REGISTER_TOGGLE_ROBOT_SELECT,
  REPEAT_OPTIONS,
  REPEAT_OPTION_MONTHLY,
  REPEAT_OPTION_NONE,
  REPEAT_OPTION_WEEKLY,
  REPEAT_OPTION_YEARLY,
} from '../../common/consts';
import AccordionCard from '../../components/AccordionCard';
import CalendarGroupSearchModal from '../../components/calendar/CalendarGroupSearchModal';
import {
  closeModal,
  getCommands,
  getGroups,
  openModal,
  registerInit,
  saveItem,
  setSchedule,
  setScheduleError,
} from '../../modules/calendarBot';
import {
  getManagerMode,
  getManagerRobotId,
  getUserId,
} from '../../common/util';
import CalendarTitleTextField from '../../components/calendar/CalendarTitleTextField';
import CalendarTimesToggleGroup from '../../components/calendar/CalendarTimesToggleGroup';
import CalendarRepeatField from '../../components/calendar/CalendarRepeatField';
import CalendarExecDateField from '../../components/calendar/CalendarExecDateField';
import CalendarCmdSwitch from '../../components/calendar/CalendarCmdSwitch';
import CalendarTargetToggleGroup from '../../components/calendar/CalendarTargetToggleGroup';
import Toast from '../../components/Toast';

const CalendarRegisterContainer = () => {
  const dispatch = useDispatch();
  const {
    groupModal: modal,
    selectDate,
    register,
    error: oldError,
  } = useSelector((state) => state.calendarBot);
  const {
    cmds,
    error,
    today,
    groups,
    group,
    schedule,
    message,
    result: registerResult,
  } = register;
  const {
    bot,
    command,
    execTime,
    title: propTitle,
    repeat,
    repeatValue,
  } = schedule;
  const { type, value, times } = repeatValue;
  const { day: dayArr, date, month } = value;

  // const [modal, setModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [defaultDate, setDefaultDate] = useState(
    moment().set({
      year: selectDate.get('year'),
      month: schedule.repeatValue.month,
      date: schedule.repeatValue.date,
    }),
  );
  const [errorDisabled, setErrorDisabled] = useState(error);
  const [title, setTitle] = useState(propTitle || '');
  const [snack, setSnack] = useState({ open: false });

  const handleInputChange = (e) => {
    setTitle(e.target.value);
    dispatch(
      setScheduleError({
        ...error,
        title: e.target.value.length ? '' : '일정 제목을 입력하세요.',
      }),
    );
  };

  const validCheckRegister = ({ data: d, groupData: gd }) => {
    const data = d || schedule;
    const groupData = gd || group;
    const { bot, command, repeat, repeatValue, execTime, title } = data;
    const error = {
      ...oldError,
      title: '',
      time: '',
      day: '',
      command: '',
      group: '',
    };
    if (title.length < 1) {
      // 제목 미입력 체크
      error.title = '일정 제목을 입력하세요.';
    }
    if (!repeat && repeatValue.type === REPEAT_OPTION_NONE) {
      const now = moment();
      const exec = moment(execTime).set({
        month: repeatValue.value.month,
        date: repeatValue.value.date,
      });
      if (exec.isSameOrBefore(now)) {
        // 일정 반복 없음 시에 실행 시간이 과거인지 체크
        error.time =
          '시작 일자와 반복 시간은 오늘 현재 시간 이후로 설정되어야 합니다.';
      }
    }
    if (repeat && repeatValue.type === REPEAT_OPTION_WEEKLY) {
      // 일정 매주 반복 시에 반복 요일 미선택 체크
      const {
        value: { day },
      } = repeatValue;
      if (Object.keys(day).length === 0) {
        error.day = '반복 실행할 요일을 선택하세요.';
      }
    }
    if (command && !bot) {
      // 명령어 실행 선택 후, 실행할 명령어 미선택 체크
      error.command = '실행할 명령어를 선택하세요.';
    }
    const { type, list } = groupData;
    if (type === REGISTER_TOGGLE_GROUP_SELECT && list.length === 0) {
      error.group = '일정을 등록할 로봇을 선택하세요.';
    }

    dispatch(setScheduleError(error));
  };

  const setRegisterSchedule = (data) => {
    dispatch(setSchedule({ schedule: { ...data } }));
    validCheckRegister({ data });
  };
  const setRegisterGroup = (groupData) => {
    dispatch(setSchedule({ group: { ...groupData } }));
    validCheckRegister({ groupData });
  };

  // eslint-disable-next-line consistent-return
  const handleScheduleChange = (e) => {
    const {
      target: { value: newVal, name },
    } = e;
    if (newVal) {
      switch (name) {
        case CAL_REGISTER_FIELD_TITLE:
          return setRegisterSchedule({
            ...schedule,
            title: newVal,
          });
        case CAL_REGISTER_FIELD_DATE:
          return setRegisterSchedule({
            ...schedule,
            execTime: execTime
              .set('year', newVal.split('-')[0])
              .set('month', newVal.split('-')[1] - 1)
              .set('date', newVal.split('-')[2]),
            repeatValue: {
              type,
              value:
                type === REPEAT_OPTION_NONE
                  ? {
                      day: [],
                      date: execTime.date(),
                      month: execTime.month(),
                    }
                  : value,
              times,
            },
          });
        case CAL_REGISTER_FIELD_TIME:
          return setRegisterSchedule({
            ...schedule,
            execTime: execTime
              .set('hour', newVal.split(':')[0])
              .set('minute', newVal.split(':')[1])
              .set('second', 0)
              .set('millisecond', 0),
          });
        case CAL_REGISTER_FIELD_WEEK:
          return setRegisterSchedule({
            ...schedule,
            repeatValue: {
              type,
              times,
              value: {
                ...value,
                day: { ...value.day, [newVal]: !value.day[newVal] },
              },
            },
          });
        case CAL_REGISTER_FIELD_CMD_TOGGLE:
          dispatch(getCommands());
          return setRegisterSchedule({
            ...schedule,
            bot: '',
            command: !command,
          });
        case `${CAL_REGISTER_FIELD_CMD}-${CAL_REGISTER_FIELD_CMD_TOGGLE}`:
          return setRegisterSchedule({
            ...schedule,
            bot: newVal.split('_')[0],
            command: newVal.split('_')[1],
          });

        case CAL_REGISTER_FIELD_MONTHLY_DATEPICKER:
          return setRegisterSchedule({
            ...schedule,
            repeatValue: {
              times,
              type,
              value: {
                day: [],
                month: newVal[0],
                date: newVal[1],
              },
            },
          });
        case CAL_REGISTER_FIELD_YEARLY_DATEPICKER:
          return setRegisterSchedule({
            ...schedule,
            repeatValue: {
              times,
              type,
              value: {
                day: [],
                month: newVal[0],
                date: newVal[1],
              },
            },
          });
        case CAL_REGISTER_FIELD_GROUP_TOGGLE:
          setRegisterGroup({
            type: newVal,
            list: newVal === group.type ? group.list : [],
          });
          break;
        default:
          setRegisterSchedule({ ...schedule });
          break;
      }
    }
  };

  const handleSelectChange = (e, name) => {
    const {
      target: { value: v, name: n },
    } = e;
    // if (type === REPEAT_OPTION_MONTHLY) {
    //   handleScheduleChange({
    //     target: { value: parseInt(v, 10), name },
    //   });
    // } else
    if (n === 'month') {
      handleScheduleChange({
        target: { value: [parseInt(v, 10), defaultDate.get('date')], name },
      });
    } else {
      handleScheduleChange({
        target: { value: [defaultDate.get('month'), parseInt(v, 10)], name },
      });
    }
  };

  const handleRepeatTypeChange = (e, newVal) => {
    if (newVal) {
      setRegisterSchedule({
        ...schedule,
        repeat: newVal !== REPEAT_OPTION_NONE,
        repeatValue: {
          type: newVal,
          value: {
            // day: [ ...REPEATVALUE_DAY_OPTIONS ],
            day: [],
            date: today.date(),
            month: today.month(),
          },
          times,
        },
      });
    }
  };

  const handleRepeatTimesChange = (e, newVal) => {
    setRegisterSchedule({
      ...schedule,
      repeatValue: {
        type,
        value,
        times: newVal,
      },
    });
  };

  const handleWeekChange = (e, newVal) => {
    setRegisterSchedule({
      ...schedule,
      repeatValue: {
        type,
        times,
        value: {
          ...value,
          day: newVal,
        },
      },
    });
  };

  const handleGroupItemChange = (value) => () => {
    const { list: groupList } = group;
    const list = groupList.filter(({ gId }) => gId === value);
    setRegisterGroup({ type: REGISTER_TOGGLE_GROUP_SELECT, list });
  };

  const handleGroupChange = (e, newVal) => {
    const val = newVal || e.target.value;
    setRegisterGroup({
      type: val,
      list: val === group.type ? group.list : [],
    });
    if (val === REGISTER_TOGGLE_GROUP_SELECT) {
      dispatch(openModal([...groups] || []));
    }
  };

  const handleNewSchedule = () => {
    const data = { execTime, repeat, userId: getUserId() };

    if (command && bot) {
      data.bot = bot;
      data.command = command;
    }
    const day = type === REPEAT_OPTION_NONE ? [] : dayArr;
    data.repeatValue = {
      type,
      value: {
        day,
        date,
        month,
        times,
      },
    };
    if (title) {
      data.title = title;
    }
    dispatch(saveItem({ data, group }));
  };

  const handleSnackClose = () => {
    dispatch(registerInit());
    dispatch(getGroups());
    setTitle('');
    setSnack({ open: false });
  };

  useUpdateEffect(() => {
    if (type === REPEAT_OPTION_MONTHLY || type === REPEAT_OPTION_YEARLY) {
      const year = selectDate.get('year');
      setDefaultDate(moment().set({ year, month, date }));
    }
  }, [schedule.repeatValue]);

  useUpdateEffect(() => {
    if (error) {
      const newValue = Object.values(error).reduce((acc, cur) => {
        if (typeof cur === 'string' && cur.length > 0) {
          return false;
        }
        return acc;
      }, true);
      setErrorDisabled(newValue);
    }
  }, [error]);

  useUpdateEffect(() => {
    if (registerResult !== null) {
      if (registerResult) {
        setTitle('');
      }
      setSnack({
        open: true,
        onClose: handleSnackClose,
        message,
        severity: registerResult ? 'success' : 'error',
      });
    }
  }, [registerResult]);

  useMount(() => {
    setTitle('');

    if (getManagerMode()) {
      setRegisterGroup({
        type: REGISTER_TOGGLE_ROBOT_SELECT,
        list: [{ robotId: getManagerRobotId() }],
      });
    } else {
      dispatch(getGroups());
    }
  });

  return (
    <>
      <AccordionCard
        {...{
          title: '일정 등록',
          open,
          done: {
            label: '완료',
            disabled: open && !errorDisabled,
            onClick: handleNewSchedule,
          },
          unfold: { label: '등록', onClick: () => setOpen(true) },
          fold: {
            label: '취소',
            onClick: () => {
              setOpen(false);
              handleSnackClose();
            },
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item container xs={12} md={6} alignSelf="baseline" spacing={1}>
            <Grid item xs={12}>
              <CalendarTitleTextField
                {...{
                  name: CAL_REGISTER_FIELD_TITLE,
                  value: title,
                  onChange: handleInputChange,
                  onBlur: handleScheduleChange,
                  error: error && 'title' in error && error.title.length > 0,
                  helperText: error && 'title' in error && error.title,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CalendarTimesToggleGroup
                {...{
                  name: CAL_REGISTER_FIELD_TIMES,
                  value: repeatValue.times || 1,
                  onChange: handleRepeatTimesChange,
                  length: 5,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CalendarRepeatField
                {...{
                  type: {
                    name: CAL_REGISTER_FIELD_REPEAT,
                    value: repeatValue.type,
                    onChange: handleRepeatTypeChange,
                    list: REPEAT_OPTIONS,
                  },
                  weekday: {
                    value: repeatValue.value.day,
                    onChange: handleWeekChange,
                  },
                  month: {
                    value: defaultDate.get('month'),
                    onChange: handleSelectChange,
                  },
                  date: {
                    name: CAL_REGISTER_FIELD_MONTHLY_DATEPICKER,
                    value: defaultDate.get('date'),
                    onChange: handleSelectChange,
                  },
                  time: {
                    name: CAL_REGISTER_FIELD_TIME,
                    value: execTime && execTime.format('HH:mm'),
                    onChange: handleScheduleChange,
                    error: error && 'time' in error && error.time.length > 0,
                    helperText: error && 'time' in error && error.time,
                  },
                }}
              />
            </Grid>
          </Grid>
          <Grid item container xs={12} md={6} alignSelf="baseline" spacing={1}>
            <Grid item xs={12}>
              <CalendarExecDateField
                {...{
                  name: CAL_REGISTER_FIELD_DATE,
                  value: execTime && execTime.format('YYYY-MM-DD'),
                  onChange: handleScheduleChange,
                  error: error && 'time' in error && error.time.length > 0,
                  helperText: error && 'time' in error && error.time,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CalendarCmdSwitch
                {...{
                  name: CAL_REGISTER_FIELD_CMD_TOGGLE,
                  command,
                  cmds,
                  onChange: handleScheduleChange,
                }}
              />
            </Grid>
          </Grid>
          {!getManagerMode() && (
            <Grid item xs={12}>
              <Divider sx={{ mb: 2 }} />
              <CalendarTargetToggleGroup
                {...{
                  name: CAL_REGISTER_FIELD_GROUP_TOGGLE,
                  value: group.type,
                  list: group.list,
                  onChange: handleGroupChange,
                  onItemChange: handleGroupItemChange,
                }}
              />
            </Grid>
          )}
        </Grid>
      </AccordionCard>
      {modal.open && (
        <CalendarGroupSearchModal
          {...{
            ...modal,
            onUpdate: (list) => {
              setRegisterGroup({ type: REGISTER_TOGGLE_GROUP_SELECT, list });
              dispatch(closeModal());
            },
            onCancel: () => dispatch(closeModal()),
          }}
        />
      )}
      <Toast {...{ ...snack }} />
    </>
  );
};

export default CalendarRegisterContainer;
